import { NumberStringPairs } from '../../../../interfaces/systemSettings/AccountTemplate'
import { ProjectForecastReportPeriod } from '../../../../interfaces/systemSettings/ProjectForecastReport'

export const periodOptions: NumberStringPairs = {
  1: 'P1',
  2: 'P2',
  3: 'P3',
}

export const periodByKey: Record<number, ProjectForecastReportPeriod> = {
  1: 'P1',
  2: 'P2',
  3: 'P3',
}

export const keyByPeriod: Record<ProjectForecastReportPeriod, number> = {
  P1: 1,
  P2: 2,
  P3: 3,
}

export const getLatestClosedPeriod = (
  date: Date
): { year: number; period: ProjectForecastReportPeriod } => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1

  if (month <= 2) {
    return {
      year: year - 1,
      period: 'P1',
    }
  }

  if (month <= 5) {
    return {
      year,
      period: 'P2',
    }
  }

  if (month <= 9) {
    return {
      year,
      period: 'P3',
    }
  }

  return {
    year,
    period: 'P1',
  }
}

export const getYearOptions = (selectedYear: number): NumberStringPairs => {
  const currentYear = new Date().getFullYear()
  const options: NumberStringPairs = {}

  for (let year = 2026; year <= currentYear + 1; year += 1) {
    options[year] = year.toString()
  }

  if (!options[selectedYear]) {
    options[selectedYear] = selectedYear.toString()
  }

  return options
}

export const buildProjectForecastUrl = (
  origin: string,
  projectId: string
): string => `${origin}/rapport/projektprognos/${projectId}`
